module.exports = __webpack_public_path__ + "img/pay_size11.3e309759.png";